import React from 'react';
import { Whitelabel } from '../hooks/useWhitelabel';

export const WhitelabelContext = React.createContext<Whitelabel | undefined>(
  undefined,
);
